module.exports = __webpack_public_path__ + "img/reason_img2.d25c6ed7.png";